import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import Refund from '../Pages/Refund'


function RefundLayout() {
  return (
    <>
    <Header />
    <Refund />
    <Footer />
    </>
  )
}

export default RefundLayout